// Generated by purs version 0.15.16
import * as API_FormType from "../API.FormType/index.js";
import * as API_Pagination from "../API.Pagination/index.js";
import * as API_RecentForms from "../API.RecentForms/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Steps_FormPicker from "../Steps.FormPicker/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Search from "../Widgets.Search/index.js";
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var map = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var multiQuery_ = /* #__PURE__ */ GraphQL_Join.multiQuery_()(/* #__PURE__ */ GraphQL_Join.jqCons(/* #__PURE__ */ GraphQL_Join.jqCons(GraphQL_Join.jqNil)({
    reflectSymbol: function () {
        return "recentForms";
    }
})()()()()(GraphQL_Query.joinGenQ))({
    reflectSymbol: function () {
        return "forms";
    }
})()()()()(GraphQL_Query.joinGenQ));
var eqRNTY = /* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString);
var elem = /* #__PURE__ */ Data_Array.elem(eqRNTY);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var fromFoldable$prime = /* #__PURE__ */ Internal_SelectionMap["fromFoldable$prime"](/* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString))(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var notEq = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons({
    reflectSymbol: function () {
        return "value";
    }
})(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons({
    reflectSymbol: function () {
        return "name";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "id";
    }
})(eqRNTY))))()({
    reflectSymbol: function () {
        return "label";
    }
})(Data_Eq.eqString))));
var RFNormal = /* #__PURE__ */ (function () {
    function RFNormal() {

    };
    RFNormal.value = new RFNormal();
    return RFNormal;
})();
var RFLoading = /* #__PURE__ */ (function () {
    function RFLoading() {

    };
    RFLoading.value = new RFLoading();
    return RFLoading;
})();
var RFError = /* #__PURE__ */ (function () {
    function RFError(value0) {
        this.value0 = value0;
    };
    RFError.create = function (value0) {
        return new RFError(value0);
    };
    return RFError;
})();
var startLoading = function (state) {
    return {
        recentForms: state.recentForms,
        selection: state.selection,
        searchState: state.searchState,
        formPicker: state.formPicker,
        searchVersion: state.searchVersion,
        state: RFLoading.value
    };
};
var setError = function (err) {
    return function (state) {
        return {
            recentForms: state.recentForms,
            selection: state.selection,
            searchState: state.searchState,
            formPicker: state.formPicker,
            searchVersion: state.searchVersion,
            state: new RFError(err)
        };
    };
};
var selectedForms = function (state) {
    return fromFoldable(Internal_SelectionMap.listSelected(state.selection));
};
var selectedDocumentIds = /* #__PURE__ */ (function () {
    var $77 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return v.id;
    });
    return function ($78) {
        return $77(selectedForms($78));
    };
})();
var rfSearchQuery = function (state) {
    var v = Widgets_Search.stateToQuery(state.searchState);
    return new API_RecentForms.FormSearchQuery({
        teacher: v.teacher,
        semester: v.semester,
        "class": v["class"],
        search: v.search,
        formIds: fromFoldable(map(function (v1) {
            return v1.id;
        })(Internal_SelectionMap.listSelected(state.formPicker.workQueueState.forms)))
    });
};
var finishLoading = function (state) {
    if (state.state instanceof RFLoading) {
        return {
            recentForms: state.recentForms,
            selection: state.selection,
            searchState: state.searchState,
            formPicker: state.formPicker,
            searchVersion: state.searchVersion,
            state: RFNormal.value
        };
    };
    return state;
};
var emptyPage = /* #__PURE__ */ API_Pagination.fromTestPage([  ]);
var initRecentFormState = function (initial) {
    var emptyRecentForms = {
        recentForms: emptyPage,
        selection: Internal_SelectionMap.empty,
        searchState: Widgets_Search.initSearchState,
        formPicker: Steps_FormPicker.emptyFormPickerState,
        state: RFNormal.value,
        searchVersion: 0
    };
    return Control_Monad_Except_Trans.runExceptT(bind(multiQuery_({
        recentForms: API_RecentForms.searchRecentForms(rfSearchQuery({
            recentForms: emptyRecentForms.recentForms,
            selection: emptyRecentForms.selection,
            formPicker: emptyRecentForms.formPicker,
            state: emptyRecentForms.state,
            searchVersion: emptyRecentForms.searchVersion,
            searchState: initial.workQueueUi.search
        })),
        forms: API_FormType.formListQuery
    }))(function (v) {
        var formPicker = Steps_FormPicker.initFormPicker(initial.workQueueState)(initial.workQueueUi)(initial.workQueueCache)(v.forms);
        var preselect = Data_Array.filter(function (f) {
            return elem(f.id)(initial.preselectForms);
        })(API_Pagination.pageItems(v.recentForms));
        return pure({
            recentForms: v.recentForms,
            selection: fromFoldable$prime(preselect),
            searchState: initial.workQueueUi.search,
            formPicker: formPicker,
            state: RFNormal.value,
            searchVersion: 0
        });
    }));
};
var applySearchChanged = function (sstate$prime) {
    return function (state) {
        var sstate = (function () {
            var $76 = notEq(Widgets_BetterSelect.selectedItem(state["searchState"]["class"]))(Widgets_BetterSelect.selectedItem(sstate$prime["class"]));
            if ($76) {
                return {
                    "class": sstate$prime["class"],
                    keyword: sstate$prime.keyword,
                    teacher: sstate$prime.teacher,
                    semester: Widgets_BetterSelect.setSelected(sstate$prime.semester)(Data_Maybe.Nothing.value)
                };
            };
            return sstate$prime;
        })();
        return {
            recentForms: state.recentForms,
            formPicker: state.formPicker,
            state: state.state,
            searchState: sstate,
            selection: Internal_SelectionMap.empty,
            searchVersion: state.searchVersion + 1 | 0
        };
    };
};
var applyRecentFormsPage = function (recentForms) {
    return function (state) {
        return {
            selection: state.selection,
            searchState: state.searchState,
            formPicker: state.formPicker,
            searchVersion: state.searchVersion,
            recentForms: recentForms,
            state: RFNormal.value
        };
    };
};
export {
    RFNormal,
    RFLoading,
    RFError,
    initRecentFormState,
    emptyPage,
    rfSearchQuery,
    applySearchChanged,
    applyRecentFormsPage,
    startLoading,
    finishLoading,
    setError,
    selectedForms,
    selectedDocumentIds
};
//# sourceMappingURL=index.js.map
